export default async function CreateScaleUnitApi(
    unitName,
    symbol,
    abbreviation,
    scaleId
  ) {
    let res = "";
    try {
      const body = {
        unitName: unitName,
        symbol: symbol,
        abbreviation: abbreviation,
        scaleId: scaleId
      };
      const token = "Bearer " + localStorage.getItem("authToken");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      };
      await fetch(
        `${process.env.REACT_APP_API_URL}v1/scale-units/`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.error("Error create scale unit: ", error);
          res = error;
        });
    } catch (error) {
      console.error(error);
      res = error;
    }
  
    return res;
  }
  